import React, { lazy } from "react";


const Spaces = lazy(() => import('features/spaces/pages/Spaces'));
const SpaceDetails = lazy(() => import('features/spaces/pages/SpaceDetails'));
const BookingPage = lazy(() => import('features/spaces/pages/Booking'));

export const SPACES_ROUTE = '/spaces';
export const BOOKING_ROUTE = '/spaces/booking';

export const spaceRoutes = [
    {
        path: SPACES_ROUTE,
        element: <Spaces />
    },
    {
        path: `${SPACES_ROUTE}/:spaceId`,
        element: <SpaceDetails />
    },
    {
        path: `${BOOKING_ROUTE}/:spaceId`,
        element: <BookingPage />
    }
];